import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import { Box } from '@mui/system';
import { Typography, TextField, InputAdornment } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

import UserService from "../services/user.service";
import AdminEditModal from "./_AdminEditModal";

export default function Admin(){
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [loading, setLoading] = useState(false);

  const GetUsers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await UserService.getAllUsers(search, page, rowsPerPage);
      setUsers(result.users);
      setTotal(result.total);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [search, page, rowsPerPage]);

  // Debounce: Suche erst 400ms nach letzter Eingabe auslösen
  useEffect(() => {
    const timeout = setTimeout(() => { GetUsers(); }, 400);
    return () => clearTimeout(timeout);
  }, [GetUsers]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(0); // bei neuer Suche zurück auf Seite 1
  };

  const handleChangePage = (e, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{background: "#F0F2F5", py: 5 }}>
      <Container maxWidth="xl">
        <Typography variant='h4' mb={3}>Admin Dashboard</Typography>

        <TextField
          fullWidth
          size="small"
          placeholder="Suche nach Name, E-Mail, Ort oder PLZ..."
          value={search}
          onChange={handleSearchChange}
          sx={{ mb: 3, background: "#fff" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"><SearchIcon /></InputAdornment>
            ),
          }}
        />

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: "bold"}}>Kunde</TableCell>
                <TableCell sx={{fontWeight: "bold"}}>E-Mail</TableCell>
                <TableCell sx={{fontWeight: "bold"}}>SharePointSecret</TableCell>
                <TableCell align="right" sx={{fontWeight: "bold"}}>Letzter Login</TableCell>
                <TableCell align="right" sx={{fontWeight: "bold"}}>Tools</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((row) => (
                <TableRow key={row.userId || row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">{row.fullname}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.secret}</TableCell>
                  <TableCell sx={{textAlign: "right"}}>{row.lastLogin}</TableCell>
                  <TableCell align="right"><AdminEditModal element={row} /></TableCell>
                </TableRow>
              ))}
              {!loading && users.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">Keine Treffer</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Zeilen pro Seite:"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} von ${count}`}
          />
        </TableContainer>
      </Container>
    </Box>
  );
};